import { BlockchainAddress, Col, Divider, Skeleton } from "@commonlibs";
import DropdownItem from "ui/common/components/input/Dropdown/DropdownItem/DropdownItem";
import UserIcon from "ui/common/icons/UserIcon";
import useTranslate from "ui/locale/hooks/useTranslate";
import useGetUserInfo from "features/users/hooks/useGetUserInfo";
import { UserMenuRoot } from "./UserMenu.styles";
import UserMenuOption from "./UserMenuOption/UserMenuOption";
import { useModal } from "@commonlibs";
import UpdateTermsAndPrivacyModal from "ui/terms/containers/UpdateTermsAndPrivacyModal/UpdateTermsAndPrivacyModal";
import { RESOURCE_BALANCE_TRANSLATIONS } from "./UserMenu.types";
import useUserState from "ui/adapter/state/useUserState";
import ResourceBalance from "ui/wallet/containers/ResourceBalance/ResourceBalance";
import ResourceNearBalance from "ui/wallet/containers/ResourceNearBalance/ResourceNearBalance";
import { RoleType } from "common/models/role/Role";
import { useLogout } from "features/auth/hooks/useLogout";

export default function UserMenu(): JSX.Element {
    const translate = useTranslate();
    const { logOut } = useLogout();
    const { selectedRole } = useUserState();
    const { showModal } = useModal();
    const { data: { fullName = "" } = {}, isLoading } = useGetUserInfo();

    const alternativeAddress =
        selectedRole?.resourceAddress === "nutresa.testnet" ? "testingpeersystem.testnet" : "fees_pideky_escala.near";

    const isOrganizationAdmin =
        selectedRole?.roleType === RoleType.ORGANIZATION_OWNER ||
        selectedRole?.roleType === RoleType.OPERATION_MANAGER ||
        selectedRole?.roleType === RoleType.CUSTOMER_SERVICE;

    return (
        <Skeleton loading={isLoading} width="11rem">
            <UserMenuRoot variant="primary" label={fullName} prefix={<UserIcon css={{ fontSize: "1.25rem" }} />}>
                <Col flex={1}>
                    {selectedRole ? (
                        <UserMenuOption label={translate("address")}>
                            <BlockchainAddress
                                ellipsis="end"
                                variant="body2Strong"
                                showCopyIcon
                                address={selectedRole.resourceAddress || ""}
                                type="address"
                                action="link"
                            />
                        </UserMenuOption>
                    ) : null}

                    {selectedRole ? (
                        <>
                            <UserMenuOption label={translate(RESOURCE_BALANCE_TRANSLATIONS[selectedRole.roleType])}>
                                {!isOrganizationAdmin && <ResourceBalance variant="body2Strong" showUnits />}
                                {isOrganizationAdmin && <ResourceNearBalance variant="body2Strong" resourceAddress={alternativeAddress} />}
                                {isOrganizationAdmin && (
                                    <ResourceNearBalance variant="body2Strong" resourceAddress={selectedRole?.resourceAddress} />
                                )}
                            </UserMenuOption>
                            {isOrganizationAdmin && (
                                <>
                                    <Divider color="overlays.0.12" />
                                    <DropdownItem
                                        onClick={() => showModal(UpdateTermsAndPrivacyModal)}
                                        label={translate("updateTermsAndPrivacy")}
                                    />
                                </>
                            )}
                        </>
                    ) : null}
                    <Divider color="overlays.0.12" />
                    <DropdownItem label={translate("logout")} onClick={() => logOut()} />
                </Col>
            </UserMenuRoot>
        </Skeleton>
    );
}
